<template>
  <div class="box">
    <el-drawer
      :visible.sync="visible"
      :wrapperClosable="false"
      :show-close="false"
      :close-on-press-escape="false"
      custom-class="drawer1"
      :size="size"
    >
      <div slot="title" style="border-bottom:1px solid #ccc;padding-bottom:10px;">
        “
        <span style="color:red">{{title}}</span>
        ” {{type== 1?"手术":"非手术"}}项目申请信息
      </div>

      <div style="padding:10px 20px;margin-bottom:80px;">
        <div>
          <span style="color:#f56c6c;text-indent:2em;padding:10px">
            众筹项目申请之前,请先下载申请必读文件并按要求以
            <b>盖章扫描件</b> 的形式上传。查看无异议，提交申请并
            <b>线下</b>向基金会
            <b>邮寄纸质合同</b>。
          </span>
          <p style="padding:10px;font-size:16px">申请必读文件：</p>
          <!-- <a
            href="javascript:;"
            style="margin-bottom:8px;font-size:14px;padding:10px;"
            v-for=" (item,index) in info.ag_files"
            :key="index"
            @click="downFile(item.file_id,item.file_name)"
          >{{item.template_name}}</a>-->
          <a
            style="margin-right:8px;font-size:14px;padding:10px;"
            :href="item.file_url"
            target="_blank"
            v-for="(item,index) in info.ag_files"
            :key="index"
          >{{item.file_name}}</a>
          <p style="margin:5px 0 0 10px;margin-bottom:10px;font-size:14px;">
            <i class="el-icon-info"></i>
            点击文件名下载文件
          </p>
        </div>

        <el-form
          :model="applyForm"
          :rules="rules"
          ref="formRef"
          label-position="top"
          style="margin-top:20px"
          :disabled="look"
        >
          <div v-if="type === 1">
            <p style="padding:10px;font-size:16px">项目各眼疾资金标准：</p>

            <el-table :data="info.funds" border max-height="400">
              <el-table-column prop="apply_user_type_text" label="贫困类型" width="200" align="center"></el-table-column>
              <el-table-column prop="cost_item_text" label="眼疾" min-width="200" align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.cost_item_text.join('、')}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="unit_text" label="眼别" width="150" align="center"></el-table-column>
              <el-table-column prop="address" label="金额区间" width="200" align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.funds_start | setNumFormat}} ~ {{scope.row.funds_end | setNumFormat}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <el-form-item label="没有找到所想申请的眼疾，请填写其他眼疾：" prop="other_cost_item" v-if="type === 1">
            <el-input
              placeholder="其他眼疾，多个请以“|”隔开"
              v-model.trim="applyForm.other_cost_item"
              style="width:60%"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="项目负责人信息：" prop="project_master">
            <el-input
              placeholder="请填写项目负责人信息"
              type="textarea"
              :rows="2"
              v-model.trim="applyForm.project_master"
              style="width:60%"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="上传项目计划书（仅一份）：" required>
            <el-upload
              ref="uploadRef2"
              multiple
              style="width:60%"
              :action="uploadFileUrl"
              :file-list="projectPlan"
              :before-upload="beforeUploadFile"
              :on-success="(response, file, fileList) =>{
                      handlerUpload(fileList,'projectPlan');
                    }"
              :on-remove="(file, fileList) =>{
                      handlerUpload(fileList,'projectPlan');
                    }"
              :limit="1"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <div class="el-icon-info">附件大小不超过300M</div>

            <p v-if="aid > 0 && projectPlan.length > 0">
              点击文件名下载文件：
              <a
                style="margin-right:8px;"
                :href="item.url"
                v-for="(item,index) in projectPlan"
                target="_blank"
                :key="index"
              >{{item.name}}</a>
            </p>
          </el-form-item>

          <el-form-item label="上传相关附件：">
            <el-upload
              ref="uploadRef1"
              multiple
              style="width:60%"
              :action="uploadFileUrl"
              :file-list="defAgList"
              :on-success="(response, file, fileList) =>{
                      handlerUpload(fileList,'defAgList');
                    }"
              :on-remove="(file, fileList) =>{
                      handlerUpload(fileList,'defAgList');
                    }"
              :before-upload="beforeUploadFile"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <div class="el-icon-info">附件大小不超过300M</div>

            <p v-if="aid > 0 && defAgList.length > 0">
              点击文件名下载文件：
              <a
                style="margin-right:8px;"
                :href="item.url"
                v-for="(item,index) in defAgList"
                target="_blank"
                :key="index"
              >{{item.name}}</a>
            </p>
          </el-form-item>
        </el-form>
      </div>
      <div class="demo-drawer-footer">
        <el-button type="danger" size="small" icon="el-icon-close" @click="cancelBtn">关闭</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-check"
          @click="submitBtn"
          :loading="loading"
          v-if="!look"
        >提交</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import baseUrl from "@/config/index";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "项目信息"
    },
    size: {
      type: [String, Number],
      default: "85%"
    },
    pid: {
      type: [String, Number],
      default: null
    },
    aid: {
      type: [String, Number],
      default: null
    },
    type: {
      type: Number,
      default: 1
    },
    look: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      loading: false,

      uploadFileUrl: "", //上传链接

      info: { funds: [], ag_files: [] }, //项目协议信息和标准信息

      applyForm: {
        id: null,
        plan_file: null,
        files: [],
        cost_item: [],
        other_cost_item: null,
        project_master: null
      }, //申请表单信息

      rules: {
        project_master: [
          { required: true, message: "请输入项目负责人信息", trigger: "blur" }
        ]
      },

      defAgList: [],
      projectPlan: []
    };
  },
  methods: {
    cancelBtn() {
      this.visible = false;
    },

    handlerUpload(fileList, name) {
      this.$set(this, name, []);
      this.$set(this, name, fileList);
    },

    //获取申请编辑数据
    getEditInfo(id) {
      this.$db.post(this.$db.config.getCfProAgDetail, { id: id }).then(res => {
        if (res && res.code == 200) {
          this.applyForm.project_master = res.data.project_master;
          if (res.data.other_cost_item && res.data.other_cost_item[0]) {
            this.applyForm.other_cost_item = res.data.other_cost_item.join("|");
          }

          if (res.data.files && res.data.files[0]) {
            this.defAgList = res.data.files;
          }

          if (res.data.plan_file && res.data.plan_file.id > 0) {
            this.projectPlan.push(res.data.plan_file);
          }
        }
      });
    },

    //获取必读协议文件列表和资金标准
    getSubmitData(id) {
      this.$db
        .post(this.$db.config.cf_project.info.files_info, { project_id: id })
        .then(res => {
          if (res && res.code == 200) {
            this.info.funds = res.data.funds;
            this.info.ag_files = res.data.ag_files;
          }
        });
    },

    // downFile(id, name) {
    //   this.$db
    //     .downFilePost(this.$db.config.downloadFileUrl, { file_id: id })
    //     .then(res => {
    //       if (res.hasOwnProperty("code")) {
    //         var enc = new TextDecoder("utf-8");
    //         var result = JSON.parse(enc.decode(new Uint8Array(res)));
    //         if (result.code !== 200) {
    //           this.$message.warning(result.msg);
    //         }
    //       } else {
    //         this.download(res, name);
    //       }
    //     });
    // },
    // // 下载文件
    // download(data, name) {
    //   if (!data) {
    //     return;
    //   }
    //   let blob = new Blob([data], { type: "application/octet-stream" });
    //   let url = window.URL.createObjectURL(blob);
    //   let alink = document.createElement("a");
    //   alink.href = url;
    //   alink.download = name; //文件名
    //   alink.click();
    //   this.downConfirm = false;
    // },

    beforeUploadFile(file) {
      let bool = this.$fnc.checkUploadFile(file);
      return bool;
    },

    //申请提交协议操作
    submitBtn() {
      this.$refs["formRef"].validate(valid => {
        if (valid) {
          let fileList1 = this.defAgList;
          let fileList2 = this.projectPlan;

          if (fileList1 && fileList1.length > 0) {
            let files = [];
            for (const key in fileList1) {
              if (fileList1[key].hasOwnProperty("response")) {
                files.push(fileList1[key].response.data.id);
              } else {
                files.push(fileList1[key].id);
              }
            }
            this.applyForm.files = files;
          }

          if (fileList2 && fileList2.length > 0) {
            let files = [];
            for (const key in fileList2) {
              if (fileList2[key].hasOwnProperty("response")) {
                files.push(fileList2[key].response.data.id);
              } else {
                files.push(fileList2[key].id);
              }
            }
            this.applyForm.plan_file = files[0];
          } else {
            this.$message.warning("请上传项目计划书！");
            return false;
          }

          this.$confirm("提交申请后还需线下向基金会邮寄纸质合同~", "提交需知", {
            confirmButtonText: "我知道了",
            cancelButtonText: "再看看",
            type: "warning"
          })
            .then(() => {
              this.loading = true;
              this.$db
                .post(this.$db.config.submitCfProAgreeAg, this.applyForm)
                .then(res => {
                  this.loading = false;
                  if (res && res.code == 200) {
                    this.$message.success(res.msg);
                    this.cancelBtn();
                    this.$emit("success");
                  }
                });
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          this.$message.warning("请填写完整表单信息！");
          return false;
        }
      });
    }
  },
  mounted() {
    this.uploadFileUrl = baseUrl + this.$db.config.uploadFileUrl;

    this.applyForm.project_id = this.pid;
    if (this.aid > 0) {
      this.applyForm.id = this.aid;
      this.getEditInfo(this.aid);
    }

    this.getSubmitData(this.pid);
  },
  watch: {
    visible(val) {
      this.$emit("input", val);
    },

    value: {
      handler(val) {
        this.visible = val;
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.box /deep/ .drawer1 {
  overflow: auto;
}
.demo-drawer-footer {
  width: 75%;
  position: fixed;
  bottom: 0;
  right: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/cfproject/info/info.vue